<template>
    <v-tooltip location="bottom right" class="custom-tooltip">
      <template v-slot:activator="{ props }">
        <v-icon
          style="font-size:20px !important; top:-1px !important;"
          color="grey"
          v-bind="props"
          class="ml-2">
          mdi-information
        </v-icon>
      </template>
      <v-row class="ageing_popup_pending pa-3" v-if="based_on_condi === 108">
        <v-col cols="12" class="text-left pa-0 mb-3"><strong>Example</strong></v-col>
        <v-col cols="12" class="text-left pa-0"><span>Initiation ageing - 7</span></v-col>
        <v-col cols="12" class="text-left pa-0"><span>Pending approval ageing - 3</span></v-col>
      </v-row>
      <v-row v-else class="ageing_popup_css pa-3">
        <v-col cols="12" class="text-left pa-0 mb-3"><strong>Example</strong></v-col>
        <v-col cols="9" class="text-left pa-0"><span>Sub-stage:</span></v-col>
        <v-col cols="3" class="text-left pa-0"><span>5</span></v-col>
        <v-col cols="9" class="text-left pa-0"><span>Disposition:</span></v-col>
        <v-col cols="3" class="text-left pa-0"><span>9</span></v-col>
        <v-col cols="9" class="text-left pa-0"><span>Inwarding:</span></v-col>
        <v-col cols="3" class="text-left pa-0"><span>12</span></v-col>
        <v-col cols="9" class="text-left pa-0"><span>Return Creation:</span></v-col>
        <v-col cols="3" class="text-left pa-0"><span>22</span></v-col>
        <v-col cols="12" class="text-left pa-0 mt-3"><span>Ageing: 5/8/12/22</span></v-col>
      </v-row>
    </v-tooltip>
  </template>
  
  <script>
  export default {
    data() {
      return {
        based_on_condi: '',
      };
    },
    name: 'AgeingTooltip',
    watch:{
      '$store.state.activeIndex'(newValue) {
        this.based_on_condi = newValue
      }
    },
    created() {
      this.based_on_condi = this.$store.state.activeIndex
  },
  }
  </script>
  <style scoped>
  .ageing_popup_css {
    width: 180px;
    background-color: white !important;
    color: black !important;
    border-radius: 8px !important;
    margin: -10px -16px !important;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    padding-left: 12px !important;
  }
  .ageing_popup_pending {
    width: 210px;
    background-color: white !important;
    color: black !important;
    border-radius: 8px !important;
    margin: -10px -16px !important;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    padding-left: 12px !important;
  }
  </style>